import React, { useContext, useEffect, useState } from "react"
import { Progress } from "./Progress"

const ProgressTrackerContext = React.createContext({
  step: 0,
  title: "",
  numSteps: 0,
  visible: false,
  setProgress: (step, title) => {},
  hideProgress: () => {}
})

export const useProgressTracker = (step?: number, title?: string) => {
  const contextValues = useContext(ProgressTrackerContext)
  useEffect(() => {
    if (step && title) {
      contextValues.setProgress(step, title)
    }
  }, [])
  return contextValues
}

export default function ProcessTracker({ children, numSteps }) {
  const [step, setStep] = useState(0)
  const [title, setTitle] = useState("")
  const [visible, setVisible] = useState(false)
  function setProgress(step, title) {
    setStep(step)
    setTitle(title)
    setVisible(true)
  }
  function hideProgress() {
    setVisible(false)
  }
  return (
    <ProgressTrackerContext.Provider value={{ step, numSteps, title, visible, setProgress, hideProgress }}>
      <ConnectedProgress />
      {children}
    </ProgressTrackerContext.Provider>
  )
}

function ConnectedProgress() {
  const { step, title, numSteps, visible } = useProgressTracker()
  return visible ? <Progress inactiveStepBackgroundColor="#DBE6EE" label={title} {...{ step, numSteps }} /> : null
}
